const reboxingProduct = JSON.parse(
  document.querySelector("[data-reboxing-data]").textContent
);

const reboxingProduct10Id = reboxingProduct.variants.find((variant) =>
  variant.title.includes("$10")
).id;
const reboxingProduct35Id = reboxingProduct.variants.find((variant) =>
  variant.title.includes("$35")
).id;

const eventsToListen = [
  window.eight.constants.events["ARMADA:CART:ADD"],
  window.eight.constants.events["ARMADA:CART:REMOVE"],
  window.eight.constants.events["ARMADA:CART:UPDATE"],
  window.eight.constants.events["ARMADA:CART:CLEAR"],
  window.eight.constants.events["ARMADA:CART:CHANGE"],
];

eventsToListen.forEach((event) => {
  document.addEventListener(event, async function (e) {
    const cart = await eight.cartEngine.getCart();
    if (!cart || !cart.items || (e.detail && e.detail.reboxIgnore)) return;

    const checkoutButtons = document.querySelectorAll(
      'button[name="checkout"]'
    );

    checkoutButtons.forEach((button) => {
      button.disabled = true;
    });

    let updates = {
      [reboxingProduct10Id]: 0,
      [reboxingProduct35Id]: 0,
    };

    cart.items.forEach((item) => {
      const properties = item.properties || {};
      const quantity = item.quantity || 1;

      if (properties["Re-boxing fee"] == "$10") {
        updates[reboxingProduct10Id] += quantity;
      } else if (properties["Re-boxing fee"] == "$35") {
        updates[reboxingProduct35Id] += quantity;
      }
    });

    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      }).then(() => {
        document.dispatchEvent(
          new CustomEvent("ARMADA:CART:ADD", { detail: { reboxIgnore: true } })
        );
      });
    } finally {
      checkoutButtons.forEach((button) => {
        button.disabled = false;
      });
    }
  });
});

document.addEventListener("ARMADA:VARIANT:CHANGE", function (e) {
  const reboxingProduct10 = document.querySelector(`[data-reboxing-fee="10"]`);
  const reboxingProduct35 = document.querySelector(`[data-reboxing-fee="35"]`);
  hideAll([reboxingProduct10, reboxingProduct35]);
  disableAllReboxingFees([reboxingProduct10, reboxingProduct35]);
  const productId = e.detail.productId;
  const variant = e.detail.variant;
  const variantSplicing = JSON.parse(
    document.querySelector(`[data-variant-splicing="${productId}"]`).textContent
  );
  const is35 = variantSplicing[variant.id] === "$35 Reboxing Fee";
  const is10 = variantSplicing[variant.id] === "$10 Reboxing Fee";
  if (is35) {
    show(reboxingProduct35);
    enableReboxingFees([reboxingProduct35]);
  } else if (is10) {
    show(reboxingProduct10);
    enableReboxingFees([reboxingProduct10]);
  }
});

function enableReboxingFees(els) {
  els.forEach((el) => {
    const input = el.querySelector("input");
    if (input) {
      input.disabled = false;
    }
  });
}

function show(el) {
  el.classList.remove("hidden");
}

function hide(el) {
  el.classList.add("hidden");
}

function hideAll(els) {
  els.forEach((el) => {
    el.classList.add("hidden");
  });
}

function disableAllReboxingFees(els) {
  els.forEach((el) => {
    const input = el.querySelector("input");
    if (input) {
      input.disabled = true;
    }
  });
}
